'use strict';
angular.module('schoolLinqApp').factory('globalUnitService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/globalUnit';

		// TODO: This endpoint is still being called by the old systemJobController. Once that is removed,
		// this service can be deleted.
		function getUnits() {
			return $http.get(endpoint + '/list');
		}

		return {
			getUnits: getUnits,
		};
	},
]);
